import * as o from "react";
import s from "../lib/IconBase.es.js";
import t from "../defs/Microscope.es.js";
const c = o.forwardRef((e, r) => /* @__PURE__ */ o.createElement(s, { ref: r, ...e, weights: t }));
c.displayName = "MicroscopeIcon";
const m = c;
export {
  m as Microscope,
  c as MicroscopeIcon
};
